import { Project } from "../types/project";
import screenSync from '../images/screensync-screenshot.webp';
import pizzaWorks from '../images/pizzaworks-screenshot.webp';
import sugarBakers from '../images/sugarbakers-screenshot.webp';
import rightOff from '../images/rightoff-temp-screenshot.webp';
import huntersGlen from '../images/HOA-screenshot.webp';

export const projects: Project[] = [
  {
    id: 1,
    title: "ScreenSync",
    iconColor: "green",
    color: "green",
    icon: "fa-solid fa-code",
    image: screenSync,
    description:
      "ScreenSync is a responsive movie and television discovery app built with React, Bootstrap, and The Movie Database (TMDb) API.",
    technologies: ["React", "Bootstrap", "API"],
    demo: "https://screensync-app.netlify.app/",
    github: "",
  },
    {
    id: 2,
    title: "PizzaWorks",
    iconColor: "purple",
    color: "purple",
    icon: "fa-solid fa-code",
    image: pizzaWorks,
    description:
      "A dynamic web app showcasing my frontend development and UX design skills. This project highlights my ability to create engaging and functional web applications.",
    technologies: ["HTML", "CSS", "JavaScript", "Bootstrap"],
    demo: "https://stephjeter.com/projects/pizzaworks",
    github: "",
  },
  {
    id: 3,
    title: "Sugarbakers",
    iconColor: "pink",
    color: "pink",
    icon: "fa-solid fa-code",
    image: sugarBakers,
    description:
    "Inspired by my love for the series Designing Women, this project combines custom theme development with my web design skills.",
    technologies: ["WordPress", "Custom Theme", "ACF", "Bootstrap", ],
    demo: "https://stephjeter.com/projects/sugarbakers",
    github: "",
  },
  {
    id: 4,
    title: "RightOff",
    iconColor: "green",
    color: "green",
    icon: "fa-solid fa-code",
    image: rightOff,
    description:
      "A Django web application for tracking tax-deductible expenses with dashboard analytics, search, filtering, and CSV export. The idea came from my experience working as a contractor.",
    technologies: ["Python", "Django", "Bootstrap", "SQLite"],
    status: "In Progress"
  },
  {
    id: 5,
    title: "HOA Site",
    iconColor: "purple",
    color: "purple",
    icon: "fa-solid fa-code",
    image: huntersGlen,
    description:
    "Built with headless WordPress and Next.js, this one-page site provides residents with neighborhood announcements, HOA board information, and downloadable documents.",
    technologies: ["Next.js", "Headless WP", "Bootstrap"],
    status: "In Progress",

  }
];